export const ActionTypes = {
  LOADING: "GET_MITIGATIONS_LOADING",
  ERROR: "GET_MITIGATIONS_ERROR",
  SUCCESS: "GET_MITIGATIONS_SUCCESS",
};
